import React from 'react';
import Template from '../Template/Template';

export const Failed = ({ handleClose }) => {
  return (
    <Template
      header={`This bank cannot be added at this time.`}
      nextButton={`Close`}
      onNextClick={handleClose}
    >
      Please contact T. Rowe Price Customer Service at{' '}
      <a className="phone"> (800) 225-5132.</a>
    </Template>
  );
};
